import axios from "@/api/axiosInstance";

export function sendSMS(payload) {
  return axios.post(`/api/v1/send/input`, payload);
}

export function scheduleSMS(payload) {
  console.log(payload);
  return axios.post(`/api/v1/schedules`, payload);
}

export function sendGroupSMS(payload) {
  return axios.post(`/api/v1/send/group`, payload);
}

export function scheduleGroupSMS(payload) {
  return axios.post(`/api/v1/schedules/group`, payload);
}

export function sendCsvSMS(payload) {
  return axios.post(`/api/v1/send/csv`, payload);
}

export function scheduleCsvSMS(payload) {
  return axios.post(`/api/v1/schedules/csv`, payload);
}
